<template>
    <b-card :title="$translate('filters')" class="text-center" body-class="p-0" title-tag="h5">

        <b-row class="mb-3">
            <b-col md="4" cols="12" class="dd mt-3 text-start">
                <label for="input-location" class="mb-3"><strong>{{ $translate('warehouse_location') }}</strong></label>
                <b-form-select class="form-control" id="input-location" v-model="historyItemsFilter.location_id"
                    :options="locations" value-field="id" text-field="name" block>
                    <template #first>
                        <b-form-select-option :value="null">
                            {{ $translate('select_all') }}
                        </b-form-select-option>
                    </template>
                    <template>
                        <b-form-select-option :value="officerOption">
                            ({{ $translate('officers') }})
                        </b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>
            <b-col md="4" cols="12" class="dd mt-3 text-start">
                <label for="input-type" class="mb-3"><strong>{{ $translate('item_type') }}</strong></label>
                
                <template v-if="historyItemsFilter.item_type_id !== undefined">
                <multiselect id="input-item_type" :placeholder="$translate('select_item_type')" 
                v-model="historyItemsFilter.item_type_id" 
                :options="itemTypesArray" 
                :searchable="true"
                :deselectLabel="deselectLabel" 
                :selectedLabel="selectedLabel" 
                :multiple="true" 
                :preserve-search="true"
                :selectLabel="selectLabel" 
                @remove="selectedItemTypes"
                @select="selectedItemTypes"
                label="name" track-by="id" :close-on-select="false">
                    <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length" v-show="!isOpen">{{ values.length }} options selected</span></template>
                </multiselect>
            </template>
            </b-col>
            <b-col md="4" cols="12" class="dd mt-3 text-start">
                <label for="input-type" class="mb-3"><strong>{{ $translate('activity_type') }}</strong></label>
                <multiselect id="input-order_type" :placeholder="$translate('select_activity_type')" 
                v-model="historyItemsFilter.order_item_type_id" 
                :options="orderTypesArray" 
                :searchable="true"
                :deselectLabel="deselectLabel" 
                :selectedLabel="selectedLabel" 
                :multiple="true" 
                :preserve-search="true"
                :selectLabel="selectLabel" 
                @remove="selectedOrderTypes"
                @select="selectedOrderTypes"
                label="name" track-by="id" :close-on-select="false">
                    <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length" v-show="!isOpen">{{ values.length }} options selected</span></template>
                </multiselect>
            </b-col>
            <b-col md="4" cols="12" class="mt-3 text-start">
                    <label for="Product" class="mb-3"><strong>{{$translate('product')}}</strong></label>
                    <b-form-input id="input-product" v-model="historyItemsFilter.product_search" value-field="id"
                        text-field="name" :placeholder="$translate('keyword_search')" block>
                    </b-form-input>
                </b-col>
            
            <b-col md="4" cols="12" class="mt-3 text-start">
                <label for="input-created_start" class="mb-3"><strong>{{ $translate('from_date') }}</strong></label>
                <b-form-input type="date" :max="historyItemsFilter.toDate" id="input-created_start"
                    v-model="historyItemsFilter.fromDate"></b-form-input>
            </b-col>
            <b-col md="4" cols="12" class="mt-3 text-start">
                <label for="input-created_end" class="mb-3"><strong>{{ $translate('to_date') }}</strong></label>
                <b-form-input type="date" :min="historyItemsFilter.fromDate" id="input-created_end" v-model="historyItemsFilter.toDate"></b-form-input>
            </b-col>
            <b-col md="4" cols="12" class="dd mt-3 text-start">
                <label for="input-officers" class="mb-3"><strong>{{ $translate('officers') }}</strong></label>
                <b-form-select  class="form-control" id="input-1" :disabled="historyItemsFilter.location_id !== officerOption" v-model="historyItemsFilter.officer_id" :options="officers"
                    value-field="id" text-field="name" block>
                    <template #first>
                        <b-form-select-option :value="null">
                            {{ $translate('select_all') }}
                        </b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>
            <b-col md="4" cols="12" class="mt-3 text-start">
                <label for=""></label>
                <b-form-checkbox id="input-include_customer" :checked-value="true" :unchecked-value="false"
                    v-model="historyItemsFilter.include_customer">&nbsp;
                    <label for="input-include_customer" class="mb-3"><strong>{{ $translate('include_customer') }}</strong></label>
                </b-form-checkbox>
            </b-col>
            <b-col md="4" cols="12" class="mt-3 text-start">
                <label for=""></label>
                <b-form-checkbox id="input-qty_sum_by_customer" :checked-value="true" :unchecked-value="false"
                    v-model="historyItemsFilter.qty_sum_by_customer">&nbsp;
                    <label for="input-qty_sum_by_customer" class="mb-3"><strong>{{ $translate('qty_sum_by_customer') }}</strong></label>
                </b-form-checkbox>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
import permissionsMixins from '@/mixins/permissionsMixins'
import Multiselect from 'vue-multiselect'

export default {
    name: 'inventoryTransfer-historyItemsQueryfilters',
    mixins: [permissionsMixins],
    components: {
        Multiselect
    },
    props: ['itemTypes','orderTypes','officers','locations','value','officerOption',],
    data() {
        return {
            itemTypesArray: [],
            orderTypesArray: [],
        }
    },
    computed: {
        historyItemsFilter: {
            // getter
            get() {
                console.log('...........', this.value)
                return this.value
            },
        },
        selectLabel() {
            return this.$translate('click_to_select')
        },
        deselectLabel() {
            return this.$translate('click_to_remove')
        },
        selectedLabel() {
            return this.$translate('selected')
        },
    },
    mounted() { 
        this.itemTypesArray = this.itemTypes
        this.orderTypesArray = this.orderTypes
    },
    methods: {
        selectedItemTypes() {
            this.itemTypesArray.sort((a, b) => a.name < b.name ? -1 : a.name > b.name ? 1 : 0);
            var selected = this.itemTypesArray.filter(s => this.historyItemsFilter.item_type_id.some(item => s.id == item.id))
            var notSelected = this.itemTypesArray.filter(s => !this.historyItemsFilter.item_type_id.some(item => s.id == item.id))
            this.itemTypesArray = [...selected, ...notSelected];
        },
        selectedOrderTypes() {
            this.orderTypesArray.sort((a, b) => a.name < b.name ? -1 : a.name > b.name ? 1 : 0);
            var selected = this.orderTypesArray.filter(s => this.historyItemsFilter.order_item_type_id.some(item => s.id == item.id))
            var notSelected = this.orderTypesArray.filter(s => !this.historyItemsFilter.order_item_type_id.some(item => s.id == item.id))
            this.orderTypesArray = [...selected, ...notSelected];
        }
    },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
